export const CREATE_PROJECT = "api/projects/"
export const GET_PROJECTS = "api/projects"
export const GET_PROJECT_BY_ID = "api/projects/id/{id}"
export const UPDATE_PROJECT = "api/projects/id/{id}"
export const DELETE_PROJECT = "api/projects/id/{id}"
export const GET_ACTIVE_PROJECTS = "api/projects/active"
export const GET_PROJECT_BY_DATE = "api/projects/by_date"
export const UPDATE_PROJECT_DESCRIPTION = "api/projects/id/{id}/update_description"
export const UPDATE_CONSULTING_FEE = "api/projects/id/{id}/update_consulting_fee"
export const UPDATE_CHECKLIST_ITEM = "api/projects/id/{id}/update_checklist_item"